import React from 'react';
import { NavLink } from 'react-router-dom';

const PrecedentsCrumb = () => <NavLink to="/core/precedents">Precedents</NavLink>;

export default PrecedentsCrumb;
